export const moduleName = 'chatSocket'
